import { render, staticRenderFns } from "./JobsHistory.vue?vue&type=template&id=4bb6bb34&scoped=true&"
import script from "./JobsHistory.vue?vue&type=script&lang=js&"
export * from "./JobsHistory.vue?vue&type=script&lang=js&"
import style0 from "./JobsHistory.vue?vue&type=style&index=0&id=4bb6bb34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6bb34",
  null
  
)

export default component.exports